module.exports = __webpack_public_path__ + "media/images/revenu-genrated-6bff75d16688642cff4ccc524b9fc29c.svg";